import React from "react";
import { CheckCircle2, Circle, CircleDot } from "lucide-react";

export default function WeekChecklist({ dayIdx = 1, checks = [], onDayToggle, toastLocked }) {
  const items = Array.from({ length: 7 }, (_, i) => i + 1);
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-2" data-testid="week-checklist-grid">
      {items.map((d) => {
        const idx = d - 1;
        const done = Boolean(checks[idx]);
        const current = d === dayIdx;
        const Icon = done ? CheckCircle2 : current ? CircleDot : Circle;
        const cls = done ? "tile-completed" : current ? "tile-current" : "tile-pending";
        const statusText = done ? "Completed" : current ? "Today" : "Locked";
        const statusPillClass = done
          ? "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-200"
          : current
            ? "bg-cyan-100 text-cyan-800 dark:bg-cyan-900/35 dark:text-cyan-200"
            : "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300";
        const handleChange = (e) => {
          const next = e.target.checked;
          if (!current) {
            e.preventDefault();
            e.stopPropagation();
            toastLocked && toastLocked(d);
            return;
          }
          onDayToggle && onDayToggle(d, next, { done, current, dayIdx });
        };
        return (
          <div key={d} className={`tile-base ${cls} py-3 px-3 text-left items-start justify-start flex-col`} style={{ height: "auto" }} data-testid={`week-checklist-day-${d}`}>
            <div className="flex items-center gap-2 w-full justify-between">
              <div className="flex items-center gap-2">
                <Icon className="h-4 w-4" />
                <div className="font-medium">DAY {d}</div>
              </div>
              <input type="checkbox" aria-label={`Toggle day ${d}`} checked={done} onChange={handleChange} className="accent-emerald-600" data-testid={`week-checklist-day-checkbox-${d}`} />
            </div>
            <div className={`mt-2 inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium border border-black/5 dark:border-white/10 ${statusPillClass}`} data-testid={`week-checklist-day-status-${d}`}>{statusText}</div>
          </div>
        );
      })}
    </div>
  );
}